import useFetchProduct from "./features/useFetchProduct";
import useBreadcrumbs from "./features/useBreadcrumbs";
import useCartController from "@/features/addToCart/useCartController";
import useRelatedProducts from "./features/useRelatedProducts";

//#region Type
interface ProductDetailViewModel {
  product: ReturnType<typeof useFetchProduct>;
  breadcrumbs: ReturnType<typeof useBreadcrumbs>;
  variations: ReturnType<typeof useCartController>["variations"];
  quantity: ReturnType<typeof useCartController>["quantity"];
  cart: ReturnType<typeof useCartController>["cart"];
  relatedProducts: ReturnType<typeof useRelatedProducts>;
}
//#endregion

const useProductDetailPage = (): ProductDetailViewModel => {
  const product = useFetchProduct();
  const breadcrumbs = useBreadcrumbs({ product: product.product });
  const { variations, quantity, cart } = useCartController({ product: product.product });
  const relatedProducts = useRelatedProducts({ product: product.product });

  return {
    product,

    breadcrumbs,

    variations,
    quantity,
    cart,

    relatedProducts,
  };
};

export default useProductDetailPage;
